import { type ReactNode } from "react"
import { Pill } from "@phosphor-icons/react"
import { HighlightedText } from "@/components/highlighted-text"
import { ListItem, ListText } from "@/components/ui/list"
import { cn } from "@/lib/utils"

interface RecommendedMedicationItemProps {
  title: string
  text: string
  searchText: string
  extra?: ReactNode
  className?: string
}
export const RecommendedMedicationItem = (props: RecommendedMedicationItemProps) => {
  return (
    <ListItem asChild>
      <div
        className="flex min-w-0 items-center"
        data-testid={`recommended-medication-item-${props.text.replace(/\s/g, "-")}`}>
        <Pill size={24} className="mr-3" />
        <div className="flex-col">
          <ListText className={cn("truncate", props.className)}>
            <HighlightedText
              className="text-on-surface truncate text-sm"
              title={props.title}
              text={props.text}
              searchValue={props.searchText}
              extendedMarkClasses="font-normal"
            />
          </ListText>
          {props.extra}
        </div>
      </div>
    </ListItem>
  )
}
